<template>
  <div>
    <div class="journey-container" :data-unique-key="solution.uniqueKey">
      <!-- Desktop View -->
      <div class="is-hidden-touch">
        <div class="columns is-mobile is-gapless mb-0 pr-1">
          <!-- AIRLINE LOGO -->
          <div class="column is-narrow has-text-centered wrap">
            <div
              v-for="(journey, journeyIndex) in solution.journeys"
              :key="journeyIndex"
            >
              <div class="airlineLogo">
                <img
                  width="20"
                  :src="
                    journey.airlineCode
                      ? $helpers.airlineLogo(journey.airlineCode, 20, 20)
                      : ''
                  "
                  :title="
                    journey.airlineCode
                      ? $helpers.airlineName(journey.airlineCode)
                      : ''
                  "
                />
              </div>
              <div class="is-size-7 has-text-grey-light">&nbsp;</div>
            </div>
          </div>
          <!-- FROM-TO -->
          <div class="column is-narrow" style="width: 150px">
            <div
              v-for="(journey, journeyIndex) in solution.journeys"
              :key="journeyIndex"
            >
              <div class="columns is-mobile is-gapless mb-2">
                <div class="column is-narrow mr-2">
                  <div class="has-text-weight-bold">
                    {{ journey.from }}
                  </div>
                </div>
                <div class="column is-narrow mr-2">
                  <span class="is-size-7 mt-1 is-block">
                    <b-icon
                      icon="arrow-right"
                      size="is-small"
                      class="has-text-grey-light"
                    ></b-icon>
                  </span>
                </div>
                <div class="column is-narrow mr-4">
                  <div class="has-text-weight-bold">
                    {{ journey.to }}
                  </div>
                </div>
                <div
                  v-if="roundTripDifferentAirports && journeyIndex == 1"
                  class="column is-narrow ml-1"
                >
                  <span class="has-text-danger is-size-7"
                    >multiple airports</span
                  >
                </div>
              </div>
              <div class="columns mb-1">
                <div class="is-size-7 has-text-grey-light ml-3">
                  {{
                    journey.airlineCode
                      ? $helpers.airlineName(journey.airlineCode)
                      : ""
                  }}
                </div>
              </div>
            </div>
          </div>
          <!-- DEPARTURE-ARRIVAl -->
          <div class="column is-narrow" style="width: 200px">
            <div
              v-for="(journey, journeyIndex) in solution.journeys"
              :key="journeyIndex"
            >
              <div class="is-inline is-size-7">
                {{ journey.legs[0].departingAt.time | formatTime }} -
                {{ journey.legs.slice(-1).pop().arrivingAt.time | formatTime }}
              </div>
              <span class="is-size-7 has-text-grey-light">
                <!-- {{ journey.legs[0].departingAt.date | formatDate}} -->
                <span
                  class="is-size-7 has-text-danger"
                  v-if="journey.dateDifference > 0"
                >
                  +{{ journey.dateDifference }}
                  <span v-if="journey.dateDifference == 1">day</span>
                  <span v-if="journey.dateDifference > 1">days</span>
                </span>
              </span>
              <!--<span class="is-block is-size-7 ml-2 has-text-danger" v-if="journey.dateDifference > 0">
                <span v-if="journey.dateDifference == 1">arrives next day</span>
                <span v-if="journey.dateDifference > 1">arrives {{ journey.dateDifference }} days layer</span>
              </span>-->
              <div class="is-size-7 has-text-grey-light">&nbsp;</div>
            </div>
          </div>
          <!-- DURATION -->
          <div class="column is-narrow has-text-right" style="width:80px">
            <div
              v-for="(journey, journeyIndex) in solution.journeys"
              :key="journeyIndex"
            >
              <span class="has-text-grey-dark is-size-7 mr-2">{{
                journey.travelDuration | formatDuration
              }}</span>
              <div class="is-size-7 has-text-grey-light">&nbsp;</div>
            </div>
          </div>
          <!-- STOPS -->
          <div class="column has-text-left mr-4">
            <div
              v-for="(journey, journeyIndex) in solution.journeys"
              :key="journeyIndex"
            >
              <span class="has-text-grey-light is-size-7 ml-2">{{
                (journey.legs.length - 1) | formatLayovers
              }}</span>

              <span
                v-for="(layover, index) in journey.layovers"
                :key="`layover-${index}`"
                class="is-size-7 has-text-grey-light"
              >
                <span class="mx-1 has-text-grey-light">
                  &bull;
                </span>

                <span
                  class="has-text-weight-bold"
                  v-bind:class="getLayoverClass(layover.durationInMinutes)"
                >
                  {{ layover.airport }}
                </span>

                <span v-bind:class="getLayoverClass(layover.durationInMinutes)">
                  {{ layover.durationInMinutes | formatDuration }}
                </span>
              </span>
              <div class="is-size-7 has-text-grey-light">&nbsp;</div>
            </div>
          </div>
          <!-- UNUSED TICKET -->
          <!-- <div class="column has-text-right is-narrow" style="width:40px;"> -->
          <!--          <div class="is-inline-block" v-if="unusedTickets.includes(solution.journeys[0].airlineCode)">-->
          <!--            <b-icon icon="currency-usd" size="is-small" type="is-info"></b-icon>-->
          <!--          </div>-->
          <!-- </div> -->
          <!-- PRICE RANGE -->
          <template v-if="useAtcShopper">
            <div class="column is-narrow has-text-right columns">
              <AtcPriceDisplay
                v-if="useAtcShopper"
                :solution="solution"
                class="column pt-0 is-narrow"
              ></AtcPriceDisplay>
              <div
                class="has-text-grey-dark is-size-7 has-text-weight-bold has-text-right column pt-0 is-narrow mr-2"
              >
                +${{ Number(solution.pricing.totalDue).toFixed(0) }}
              </div>
            </div>

            <div
              class="column is-narrow has-text-success has-text-weight-bold is-size-7 mr-2"
            >
              (${{ Number(solution.pricing.residualValue).toFixed(0) }})
            </div>
          </template>

          <div
            v-else
            class="column is-narrow has-text-right mr-2"
            style="width:120px"
          >
            <div class="has-text-grey-dark is-size-6 has-text-weight-bold">
              <span>{{ solution.pricing.total | formatPriceFromDollars }}</span>
            </div>

            <!-- Fare Upsell Options -->
            <div v-if="solution.upsellsCount > 0">
              <b-tag class="is-small mt-2">
                {{ solution.pricing.total | formatPriceFromDollars }} -
                {{ fareDescription }}
              </b-tag>
              <br />

              <div
                v-if="ndcFare == false"
                class="has-text-primary is-clickable is-size-7 mt-2"
                @click="toggleFareOptions"
              >
                See more fare options
              </div>
            </div>

            <NDCTag v-if="ndcFare" class="mt-3" position="is-left"></NDCTag>
          </div>
          <!-- FARE RULES (One-Way Only) -->
          <div class="column is-narrow" v-if="isOneWay">
            <div class="is-flex">
              <div
                class="is-inline-block mr-2 is-clickable"
                @click="fareRulesModal(solution.journeys)"
              >
                <b-icon
                  icon="alpha-f-circle"
                  size="is-default"
                  class="has-text-grey-lighter"
                >
                </b-icon>
              </div>
            </div>
          </div>
          <!-- RATING -->
          <div class="column is-narrow">
            <div class="mr-2">
              <!-- $popper Tooltip -->
              <section class="is-inline-block ml-1 mr-1">
                <div ref="topArrow">
                  <span
                    class="score is-clickable"
                    :class="scoreClass"
                    @mouseenter="
                      $popper.togglePopper($refs.topArrow, $refs.topMenu)
                    "
                    @mouseleave="
                      $popper.togglePopper($refs.topArrow, $refs.topMenu)
                    "
                  >
                    <span class="score-numerator inner-circle">{{
                      scoreOutOfTen
                    }}</span>
                  </span>
                </div>
                <div
                  ref="topMenu"
                  class="filterBox popper-popup"
                  style="background: #eee; max-width: 200px;"
                >
                  <p class="is-size-7">
                    Rating is based on price, travel duration, company
                    preferences, and travel preferences.
                  </p>
                  <div class="popper-arrow"></div>
                </div>
              </section>
            </div>
          </div>
          <!-- FLIGHT INFO -->
          <div class="column is-narrow">
            <div class="is-flex">
              <div
                class="is-inline-block mr-1 is-clickable"
                @click="toggleDetails"
              >
                <!--              <b-icon-->
                <!--                  icon="information"-->
                <!--                  size="is-default"-->
                <!--                  class="has-text-grey-lighter"-->
                <!--              />-->
                <b-button type="is-outlined" size="is-small"
                  >View Details</b-button
                >
              </div>
              <div
                v-if="
                  solution.isSelectable &&
                    !isPrevented
                "
                class="is-inline-block is-clickable"
                style="width: 60px;"
              >
                <b-button
                  @click="checkSubmission(solution)"
                  type="is-primary"
                  size="is-small"
                  >Book
                </b-button>
              </div>
            </div>

            <div
              v-if="!solution.isSelectable"
              class="mt-4 is-size-7 has-text-grey is-block"
            >
              Not selectable
            </div>

            <div
              v-if="
                solution.isSelectable &&
                isPrevented
              "
              class="mt-4 notification is-size-7 has-text-grey has-text-centered"
            >
              To book this option call: <br />
              877-924-0303
            </div>

            <div class="has-text-right mt-5">
              <div v-if="solution.travelPolicy" class="is-block">
                <OutOfPolicyTag
                  position="is-bottom"
                  :travelPolicy="solution.travelPolicy"
                />
              </div>
              <div
                class="is-block"
                v-if="
                  solution.journeys[0] &&
                    unusedTickets.includes(solution.journeys[0].airlineCode)
                "
              >
                <b-tag type="is-info is-light">
                  <b-icon icon="currency-usd" size="is-small"></b-icon>
                  <span>Unused Ticket</span>
                </b-tag>
              </div>
              <!-- Immediate travel -->
              <div v-if="solution.immediateTravelBookingAdvice">
                <ImmediateTravelNote
                  :severity="solution.immediateTravelBookingAdvice"
                />
              </div>
              <!-- End Immediate travel -->

              <!-- Residual Loss -->
              <div v-if="lostValue > 200">
                <b-tooltip label="Forfeited value greater than $200">
                  <b-tag type="is-danger">
                    <b-icon icon="alert" size="is-small"></b-icon>
                    <span>Residual loss</span>
                  </b-tag>
                </b-tooltip>
              </div>
            </div>
          </div>
          <!--  SEAT MAP -->
          <!--        <div class="column is-narrow mr-1">-->
          <!--          <div class="is-flex">-->
          <!--            <div class="is-inline-block is-clickable" @click="goToSeatMaps()">-->
          <!--              <b-button type="is-outlined" size="is-small">-->
          <!--                <span class="">Seat Maps</span>-->
          <!--              </b-button>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--        </div>-->
        </div>
        <!-- end of .columns -->
      </div>
      <!-- end of Desktop View -->

      <!--  Mobile view -->
      <div class="is-hidden-desktop p-2">
        <div class="is-flex is-justify-content-space-between">
          <div>
            <NDCTag v-if="ndcFare" class="mb-2" position="is-left"></NDCTag>
            <div class="columns is-mobile">
              <!-- AIRLINE LOGO -->
              <div class="column is-narrow has-text-centered wrap">
                <div
                  v-for="(journey, journeyIndex) in solution.journeys"
                  :key="journeyIndex"
                >
                  <div class="airlineLogo">
                    <img
                      width="20"
                      :src="
                        journey.airlineCode
                          ? $helpers.airlineLogo(journey.airlineCode, 20, 20)
                          : ''
                      "
                      :title="
                        journey.airlineCode
                          ? $helpers.airlineName(journey.airlineCode)
                          : ''
                      "
                    />
                  </div>
                  <div class="is-size-7 has-text-grey-light">&nbsp;</div>
                </div>
              </div>
              <!-- FROM-TO -->
              <div class="column is-narrow">
                <div class="journeys-summary-container">
                  <JourneySummaryAlt
                    v-for="(journey, journeyIndex) in solution.journeys"
                    :key="journeyIndex"
                    :journey="journey"
                    :index="journeyIndex"
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="has-text-right mr-2">
              <span class="has-text-grey-dark is-size-7 has-text-weight-bold">
                {{ solution.pricing ? solution.pricing.total : "" }}
              </span>
            </div>
            <div class="score-container has-text-justified is-size-7">
              <div class="">
                <!-- $popper Tooltip -->
                <section class="is-inline-block ml-1 mr-2">
                  <div ref="topArrow">
                    <span
                      class="score is-clickable"
                      :class="scoreClass"
                      @mouseenter="
                        $popper.togglePopper($refs.topArrow, $refs.topMenu)
                      "
                      @mouseleave="
                        $popper.togglePopper($refs.topArrow, $refs.topMenu)
                      "
                    >
                      <span class="score-numerator inner-circle">{{
                        scoreOutOfTen
                      }}</span>
                    </span>
                  </div>
                  <div
                    ref="topMenu"
                    class="filterBox popper-popup"
                    style="background: #eee; max-width: 200px;"
                  >
                    <p class="is-size-7">
                      Rating is based on price, travel duration, company
                      preferences, and travel preferences.
                    </p>
                    <div class="popper-arrow"></div>
                  </div>
                </section>
              </div>
            </div>
            <!-- FARE RULES (One-Way Only) -->
            <div class="has-text-right mr-2" v-if="isOneWay">
              <div
                class="is-clickable"
                @click="fareRulesModal(solution.journeys)"
              >
                <b-icon
                  icon="alpha-f-circle"
                  size="is-default"
                  class="has-text-grey-lighter"
                >
                </b-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="is-flex is-justify-content-center mb-3">
          <div class="">
            <div v-if="solution.travelPolicy" class="is-block">
              <OutOfPolicyTag
                position="is-bottom"
                :travelPolicy="solution.travelPolicy"
                class="mr-1"
              />
            </div>
            <div
              class="is-block"
              v-if="
                solution.journeys[0] &&
                  unusedTickets.includes(solution.journeys[0].airlineCode)
              "
            >
              <b-tag type="is-info is-light">
                <b-icon icon="currency-usd" size="is-small"></b-icon>
                <span>Unused Ticket</span>
              </b-tag>
            </div>
            <!-- Immediate travel -->
            <div v-if="solution.immediateTravelBookingAdvice">
              <ImmediateTravelNote
                :severity="solution.immediateTravelBookingAdvice"
              ></ImmediateTravelNote>
            </div>
            <!-- End Immediate travel -->

            <!-- Residual Loss -->
            <div v-if="lostValue > 200">
              <b-tooltip label="Forfeited value greater than $200">
                <b-tag type="is-danger">
                  <b-icon icon="alert" size="is-small"></b-icon>
                  <span>Residual loss</span>
                </b-tag>
              </b-tooltip>
            </div>
          </div>
        </div>
        <div class="is-flex is-justify-content-center">
          <!-- FLIGHT INFO -->
          <div class="">
            <div class="is-flex">
              <div
                class="is-inline-block mr-1 is-clickable"
                @click="$emit('display')"
              >
                <!--              <b-icon-->
                <!--                  icon="information"-->
                <!--                  size="is-default"-->
                <!--                  class="has-text-grey-lighter"-->
                <!--              />-->
                <b-button type="is-outlined" size="is-small"
                  >View Details</b-button
                >
              </div>
            </div>
          </div>
          <div class="">
            <div class="is-flex">
              <div
                v-if="solution.isSelectable && !isPrevented"
                class="is-inline-block is-clickable"
                style="width: 70px;"
              >
                <b-button
                  @click="checkSubmission(solution)"
                  type="is-primary"
                  size="is-small"
                  >Book</b-button
                >
              </div>
            </div>

            <div
              v-if="!solution.isSelectable"
              class="is-size-7 has-text-grey is-block"
            >
              Not selectable
            </div>

            <div
              v-if="solution.isSelectable && isPrevented"
              class="notification is-size-7 has-text-grey has-text-centered"
            >
              To book this option call: <br />
              877-924-0303
            </div>
          </div>
        </div>
      </div>
      <!--  end of Mobile view -->
    </div>
    <!-- end of .journey-container -->

    <!-- SHOW DETAILS OF THE FLIGHT -->
    <div v-if="showDetails" class="flight-details-container mt-5">
      <FlightDetails :journeys="solution.journeys" @filter="filterByFlight" />
    </div>
  </div>
</template>

<script>
import OutOfPolicyTag from "../../Tags/OutOfPolicyTag.vue";
import FlightDetails from "./FlightDetails.vue";
import SeatMapMenu from "../../SeatMap/SeatMapMenu.vue";
import meetingsMixin from "../../../mixins/meetingsMixin";
import modalMixin from "../../../mixins/modalMixin";
import bookingMixin from "@/mixins/bookingMixin";
import ImmediateTravelNote from "../../Traveller/ImmediateTravelNote";
import JourneySummaryAlt from "./JourneySummaryAlt";
import AddMeetingGuest from "../../Meetings/AddMeetingGuest.vue";
import NDCTag from "../../Tags/NDCTag.vue";
import AtcPriceDisplay from "./AtcPriceDisplay.vue";

export default {
  name: "SearchByScheduleSummary",
  mixins: [meetingsMixin, modalMixin, bookingMixin],
  components: {
    AtcPriceDisplay,
    OutOfPolicyTag,
    FlightDetails,
    ImmediateTravelNote,
    JourneySummaryAlt,
    NDCTag,
  },
  props: {
    solution: {
      journeys: [],
    },
    first_selected: Boolean,
    searchDetails: Object,
  },
  data: function() {
    return {
      display_full: false,
      path: "",
      time: "",
      price: "",
      score: "",
      stops: [],
      scoreOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      isDesktop: true,
      showDetails: false,
      roundTripDifferentAirports: false,
    };
  },
  computed: {
    useAtcShopper() {
      return this.$store.state.bookTravel.atc?.useAtcShopper;
    },
    originalFare() {
      return this.$store.state.bookTravel?.atc?.price || null;
    },
    newFare() {
      return Number(this.solution.pricing.total) || 0;
    },
    residualValue() {
      return Number(this.solution.pricing.residualValue);
    },
    lostValue() {
      return this.originalFare - this.newFare - this.residualValue;
    },
    isPrevented() {
      let prevented = false;
      if (this.solution.immediateTravelBookingAdvice == "prevent") {
        prevented = true;
      }
      if (this.lostValue > 200) {
        prevented = true;
      }
      return prevented;
    },
    ndcFare() {
      return this.solution.offer != null;
    },
    tripType() {
      return this.$store.state.bookTravel.result.itineraryType;
    },
    unusedTickets() {
      if (this.pathMixin_isMeeting) {
        return [];
      }
      if (
        this.$store.getters["travellersAndTrips/getCurrentTravellerProfile"]
          .unusedTicketAirlines
      ) {
        return this.$store.getters[
          "travellersAndTrips/getCurrentTravellerProfile"
        ].unusedTicketAirlines;
      } else {
        return [];
      }
    },
    fareDescription() {
      return this.solution.fareFamily?.familyDescription || "";
    },
    // roundTripDifferentAirports(journeyIndex) {
    //   if (this.tripType == 1) {
    //     return this.solution.journeys[0].from != this.solution.journeys[1].to ||
    //     this.solution.journeys[0].to != this.solution.journeys[1].from
    //   }
    //   return false
    // },
    triggerMessages() {
      var message = "";
      for (
        let i = 0;
        i < this.solution.travelPolicy.rulesTriggered.length;
        i++
      ) {
        message +=
          this.solution.travelPolicy.rulesTriggered[i].message + "  |  ";
      }
      return message;
    },
    scoreOutOfTen() {
      return this.$options.filters.displayScore(this.solution.score);
    },
    scoreClass() {
      return (
        "score-" + this.scoreOutOfTen + " outer-circle-" + this.scoreOutOfTen
      );
    },
    scoreOptionClass() {
      return "score-bar-" + this.scoreOutOfTen;
    },
    activeScoreBarClass() {
      return "active-score-bar";
    },
    flightForItinerary() {
      var sol = this.solution;
      sol.unusedTicket = this.unusedTickets.includes(
        sol.journeys[0].airlineCode
      );
      for (var i = 0; i < sol.journeys.length; i++) {
        // console.log(i)
        for (var j = 0; j < sol.journeys[i].legs.length; j++) {
          // console.log(j)
          sol.journeys[i].legs[j].selectedSeat = false;
        }
      }
      return sol;
    },
    solutionAirlineCodes() {
      var airlines = [];

      for (let journey of this.solution.journeys) {
        airlines.push(journey.airlineCode);
      }

      return airlines;
    },
    solutionAirlineNames() {
      var airlineNames = [];

      for (let airlineCode of this.solutionAirlineCodes) {
        airlineNames.push(this.$globals.airlineNames[airlineCode]);
      }

      return airlineNames;
    },
  },
  methods: {
    filterByFlight(val) {
      this.display_full = false;
      this.$emit("filter", val);
    },
    async flightSelected() {
      this.$store
        .dispatch("bookTravel/alterResult", this.solution)
        .then(this.$router.push({ path: "/itinerary" }));
    },
    getLayoverClass(durationInMinutes) {
      if (durationInMinutes > 180 || durationInMinutes < 45) {
        return "has-text-danger";
      }

      return "";
    },
    display() {
      this.display_full = !this.display_full;
      //// console.log('called display()');
    },
    getAirportLocation(airportCode) {
      let airport = this.$globals.airports.find(
        (airportItem) => airportItem.code === airportCode
      );

      if (!airport) return null;

      return airport.city + ", " + airport.state;
    },
    toggleFareOptions() {
      if (this.$store.state.bookTravel.fareOptions.show) {
        this.$store.commit("bookTravel/HIDE_FARE_OPTIONS");
      } else {
        let details = {
          show: true,
          solution: this.solution,
        };
        this.$store.commit("bookTravel/SET_FARE_OPTIONS", details);
      }
    },
    goToSeatMaps() {
      var details;
      details = {
        parent: this,
        component: SeatMapMenu,
        props: {
          activeTab: 0,
          flightProp: this.solution.journeys,
          preview: true,
        },
        hasModalCard: true,
        trapFocus: true,
      };
      this.$buefy.modal.open(details);
    },
    availableSeats(num) {
      if (num == "9") {
        return "9+";
      }
      return num;
    },
    checkScreenSize() {
      if (window.innerWidth <= 1023) {
        // console.log('window.innerWidth: ', window.innerWidth);
        this.isDesktop = false;
      }
    },
    checkSubmission(sol) {
      // console.log('checkSubmission', sol);

      if (sol.immediateTravelBookingAdvice == "warn") {
        this.$buefy.dialog.confirm({
          message:
            "You have selected a flight with a departure time in the next few hours. Please watch your email for your Final Ticketed Itinerary.  If you do not receive your Final Ticketed Itinerary, please contact Gant Travel Support at 877-924-0303 for assistance.   ",
          confirmText: "Continue booking",
          type: "is-info",
          hasIcon: true,
          onConfirm: () => this.submitted(sol),
        });
      } else {
        this.submitted(sol);
      }
    },
    submitted(value) {
      //NDC Fare
      if (this.ndcFare) {
        let payload = {
          flight: this.solution,
          offer: this.solution.offer,
        };

        this.$store.dispatch("bookTravel/setNdcBooking", payload);

        this.$router.push({ path: "ndc-fare-options" });
      } else {
        this.$store.dispatch("bookTravel/alterResult", value);

        if (this.pathMixin_isMeeting) {
          this.meetingRouter();

          if (this.meetingInfo.allowedToBringGuest) {
            this.$buefy.modal.open({
              parent: this,
              component: AddMeetingGuest,
              props: {},
              hasModalCard: true,
              trapFocus: true,
              width: 650,
            });
          }
        } else if (this.$store.state.bookTravel.atc?.useAtcShopper) {
          this.$nav.pushRouteTo({ name: "ExchangeCheckout" });
        } else {
          this.$nav.pushRouteTo({ name: "BookingItinerary" });
        }
      }
    },
    toggleDetails() {
      //console.log('toggleDetails')
      this.showDetails = !this.showDetails;
    },
  },
  mounted() {
    this.checkScreenSize();
  },
};
</script>

<style lang="scss" scoped>
$scoreColors: (
  "10": #39996b,
  "9": #47ba41,
  "8": #abba19,
  "7": #f0dd01,
  "6": #ffce00,
  "5": #ffa600,
  "4": #ff7500,
  "3": #ff4e02,
  "2": #d21d00,
  "1": #a52620,
);
@each $score, $color in $scoreColors {
  .inner-circle {
    border-radius: 106%;
    display: inline-block;
    padding: 0;
    height: 26px;
    width: 26px;
    background: white;
  }
  .outer-circle-#{$score} {
    border-radius: 50%;
    display: inline-block;
    padding: 3px 2px 28px 2px;
    height: 32px;
    width: 32px;
    @if $score == "10" {
      background: linear-gradient(-20deg, $color 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(to right, $color 50%, transparent 0),
        $color;
    } @else if $score == "9" {
      background: linear-gradient(270deg, $color 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(54deg, $color 50%, transparent 0),
        white;
    } @else if $score == "8" {
      background: linear-gradient(270deg, $color 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(18deg, $color 50%, transparent 0),
        white;
    } @else if $score == "7" {
      background: linear-gradient(270deg, $color 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(-18deg, $color 50%, transparent 0),
        white;
    } @else if $score == "6" {
      background: linear-gradient(270deg, $color 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(-54deg, $color 50%, transparent 0),
        white;
    } @else if $score == "5" {
      background: linear-gradient(270deg, $color 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(-90deg, $color 50%, transparent 0),
        white;
    } @else if $score == "4" {
      background: linear-gradient(90deg, white 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(54deg, white 50%, transparent 0),
        $color;
    } @else if $score == "3" {
      background: linear-gradient(90deg, white 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(18deg, white 50%, transparent 0),
        $color;
    } @else if $score == "2" {
      background: linear-gradient(90deg, white 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(-18deg, white 50%, transparent 0),
        $color;
    } @else if $score == "1" {
      background: linear-gradient(90deg, white 50%, transparent 0),
        /*adjust the deg value here to control the %*/
          linear-gradient(-54deg, white 50%, transparent 0),
        $color;
    }
  }
  .score-#{$score} {
    //border: darken($color, 5) 2px solid;
    color: darken($color, 30);
    text-align: center;
    margin-left: 5px;
    font-weight: bold;
    font-size: 14px;
    line-height: 24px;
  }

  .score-bar-#{$score} {
    background-color: $color;
    text-align: center;
    width: 10px;
    height: 5px;
    display: inline-block;
    margin-left: 1px;
    font-weight: bold;
    font-size: 0;
    color: white;
  }
}
.active-score-bar {
  height: 20px;
  width: 20px;
  font-size: 12px;
  line-height: 20px;
}
.score-denominator {
  font-size: 10px;
  color: #aaa;
  display: none;

  &:before {
    content: "/";
    margin-left: 3px;
    margin-right: 3px;
    color: #ccc;
  }
}
.journey-details {
  //padding-left: 80px;
  padding: 0 5px;
  overflow-x: auto;
  overflow-y: hidden;
}
</style>
